/* The Dog Face — comportamenti delle sezioni tdf-* (20/10). Caricato in layout/theme.liquid (defer).
   - Tabella taglie [data-tdf-sg]: cm/pollici, "trova la taglia" (snippets/tdf-size-chart.liquid). Usata dalla pagina
     guida taglie e dalla finestra taglie della scheda prodotto; "Select size X" manda l'evento tdf:size-pick.
   - Scheda prodotto [data-tdf-pdp] (sections/tdf-product.liquid): galleria (sul telefono scorrimento nativo con
     scroll-snap, contatore e puntini), taglie, colori (altri prodotti dello stesso modello, con la stessa taglia),
     aggiungi al carrello (window.studio.addToCart del tema di base → carrello laterale), finestra taglie. */
(function () {
  'use strict';

  /* ------------------------------------------------------------ tabella taglie */
  function parts(raw) { return String(raw).split(/[-–]/).map(parseFloat).filter(function (x) { return !isNaN(x); }); }

  function initSizeChart(root) {
    if (root.dataset.tdfBound) return;
    root.dataset.tdfBound = '1';
    var unit = 'cm';
    var chestI = parseInt(root.dataset.chest, 10);
    var ease = parseFloat(root.dataset.ease) || 0;
    var msgs = {};
    try { msgs = JSON.parse(root.querySelector('[data-tdf-sg-msgs]').textContent); } catch (e) { /* testi di riserva sotto */ }
    var table = root.querySelector('[data-tdf-sg-table]');
    var rows = table ? Array.prototype.slice.call(table.tBodies[0].rows) : [];
    var input = root.querySelector('[data-tdf-sg-input]');
    var res = root.querySelector('[data-tdf-sg-res]');
    var pickBtn = root.querySelector('[data-tdf-sg-pick]');

    function fmt(cm) { return unit === 'cm' ? String(cm) : String(Math.round(cm / 2.54 * 2) / 2); }
    function fmtCell(raw) { return parts(raw).map(fmt).join('–'); }
    function chestOf(tr) {
      var td = tr.cells[chestI + 1];
      if (!td || !td.dataset.cm) return null;
      var v = parts(td.dataset.cm);
      return v.length ? Math.max.apply(null, v) : null;
    }
    function render() {
      root.querySelectorAll('[data-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.unit === unit ? 'true' : 'false'); });
      root.querySelectorAll('td[data-cm]').forEach(function (td) { td.textContent = fmtCell(td.dataset.cm); });
      root.querySelectorAll('[data-tdf-sg-unit]').forEach(function (s) { s.textContent = unit; });
    }
    function find() {
      if (!input || !res) return;
      var v = parseFloat(String(input.value).replace(',', '.'));
      rows.forEach(function (tr) { tr.classList.remove('is-on'); });
      res.hidden = false;
      var sizeEl = res.querySelector('[data-tdf-sg-size]'), msgEl = res.querySelector('[data-tdf-sg-msg]');
      if (pickBtn) pickBtn.hidden = true;
      if (!(v > 0)) { sizeEl.textContent = ''; msgEl.textContent = msgs.invalid || ''; return; }
      var cm = unit === 'cm' ? v : v * 2.54;
      var pick = null, next = null;
      for (var i = 0; i < rows.length; i++) {
        var c = chestOf(rows[i]);
        if (c !== null && c >= cm) { pick = rows[i]; next = rows[i + 1] || null; break; }
      }
      if (!pick) { sizeEl.textContent = '–'; msgEl.textContent = msgs.tooBig || ''; return; }
      pick.classList.add('is-on');
      var size = pick.dataset.size, limit = chestOf(pick);
      var msg = (msgs.fit || '').replace('[size]', size).replace('[chest]', fmt(limit) + ' ' + unit);
      if (next && limit - cm < ease) msg += ' ' + (msgs.close || '').replace('[next]', next.dataset.size);
      sizeEl.textContent = size;
      msgEl.textContent = msg;
      if (pickBtn) {
        pickBtn.dataset.size = size;
        pickBtn.textContent = (msgs.pick || 'Select size [size]').replace('[size]', size);
        pickBtn.hidden = false;
      }
      // telefoni piccoli (24-10): il risultato restava sotto il bordo dello schermo, anche con la tastiera aperta
      if (input === document.activeElement) input.blur();
      setTimeout(function () { (pickBtn && !pickBtn.hidden ? pickBtn : res).scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 60);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-unit]');
      if (b) { unit = b.dataset.unit; render(); if (input && input.value) find(); return; }
      var p = e.target.closest('[data-tdf-sg-pick]');
      if (p) document.dispatchEvent(new CustomEvent('tdf:size-pick', { detail: { size: p.dataset.size } }));
    });
    var form = root.querySelector('[data-tdf-sg-find]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      find();
      if (input) input.blur(); // chiude la tastiera del telefono: si vedono subito risultato e tabella
    });
  }

  /* ------------------------------------------------------------ finestre laterali (taglie) */
  // Blocco della pagina come il carrello del tema (html.studio-scroll-lock: overflow hidden su html e body). Fissare il body
  // (position: fixed) faceva ricomparire la barra di Chrome e "zoomare" la pagina (20/10): tolto.
  var lastFocus = null;
  function lockPage() { document.documentElement.classList.add('tdf-drawer-open'); }
  function unlockPage() { document.documentElement.classList.remove('tdf-drawer-open'); }
  function openDrawer(d) {
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    lockPage();
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    var f = d.querySelector('[data-tdf-drawer-close]');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 50);
  }
  function closeDrawer(d) {
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    unlockPage();
    setTimeout(function () { d.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tdf-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(document.getElementById(o.getAttribute('data-tdf-drawer-open'))); return; }
    // da altre sezioni della pagina (es. "Not sure of the size?"): la finestra taglie della scheda prodotto
    var so = e.target.closest('[data-tdf-size-open]');
    if (so) { e.preventDefault(); openDrawer(document.querySelector('[data-tdf-size-drawer]')); return; }
    var c = e.target.closest('[data-tdf-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.tdf-drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('.tdf-drawer.is-open');
    if (d) closeDrawer(d);
  });

  /* ------------------------------------------------------------ scheda prodotto */
  function initProduct(root) {
    if (root.dataset.tdfBound) return;
    root.dataset.tdfBound = '1';
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-tdf-pdp-json]').textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var sizeIndex = data.sizeIndex; // posizione dell'opzione taglia (0, 1, 2) o -1
    var idInput = root.querySelector('[data-tdf-variant-id]');
    var sizesBox = root.querySelector('[data-tdf-sizes]');
    var sizeName = root.querySelector('[data-tdf-size-name]');
    var priceEl = root.querySelector('[data-tdf-price]');
    var msg = root.querySelector('[data-tdf-add-msg]');
    var addBtn = root.querySelector('[data-tdf-add]');
    var current = null;
    var stk = root.querySelector('[data-tdf-sticky]');
    var stkPrice = stk && stk.querySelector('[data-tdf-stk-price]');
    var stkPill = stk && stk.querySelector('[data-tdf-stk-pill]');
    var stkPillText = stkPill && stkPill.querySelector('[data-tdf-stk-pill-text]');

    function variantFor(size) {
      for (var i = 0; i < variants.length; i++) if (sizeIndex < 0 || variants[i].options[sizeIndex] === size) return variants[i];
      return null;
    }
    function selectSize(size, opts) {
      var v = variantFor(size);
      if (!v) return;
      if (!v.available) { if (msg) msg.textContent = (data.strings.soldOut || '').replace('[size]', size); return; }
      current = v;
      if (idInput) idInput.value = v.id;
      if (sizesBox) sizesBox.classList.remove('is-err');
      // taglie della scheda e della loro copia nella barra fissa (24-10)
      root.querySelectorAll('[data-tdf-sizes] [data-size], [data-tdf-stk-sizes] [data-size]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.size === size ? 'true' : 'false'); });
      root.querySelectorAll('[data-tdf-size-name]').forEach(function (s) { s.textContent = ': ' + size; });
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
      if (stkPrice && v.price_html) stkPrice.innerHTML = v.price_html.replace(/<span class="tdf-off">[\s\S]*?<\/span>/, '');
      if (stkPillText && size) stkPillText.textContent = (stkPill.dataset.word || 'Size') + ' ' + size;
      if (msg) msg.textContent = '';
      if (!opts || !opts.keepUrl) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) { /* niente */ }
      }
      // i colori portano alla stessa taglia
      root.querySelectorAll('[data-tdf-colour-link]').forEach(function (a) {
        var map = {};
        try { map = JSON.parse(a.dataset.sizes || '{}'); } catch (e) { /* niente */ }
        var base = a.getAttribute('href').split('?')[0];
        a.setAttribute('href', map[size] ? base + '?variant=' + map[size] : base);
      });
    }
    if (sizesBox) {
      sizesBox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-size]');
        if (b) selectSize(b.dataset.size);
      });
    }
    document.addEventListener('tdf:size-pick', function (e) {
      var size = e.detail && e.detail.size;
      if (!size) return;
      if (variantFor(size)) {
        selectSize(size);
        closeDrawer(document.querySelector('.tdf-drawer.is-open'));
      } else if (msg) {
        msg.textContent = (data.strings.notInColour || '').replace('[size]', size);
        closeDrawer(document.querySelector('.tdf-drawer.is-open'));
      }
    });
    if (data.selected) {
      var pre = variants.filter(function (v) { return String(v.id) === String(data.selected); })[0];
      if (pre && pre.available) selectSize(sizeIndex < 0 ? null : pre.options[sizeIndex], { keepUrl: true });
    }
    if (sizeIndex < 0 && variants.length === 1) { current = variants[0]; if (idInput) idInput.value = current.id; }

    var form = root.querySelector('[data-tdf-pdp-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current) {
        if (sizesBox) { sizesBox.classList.add('is-err'); var first = sizesBox.querySelector('[data-size]:not([aria-disabled="true"])'); if (first) first.focus(); }
        if (msg) msg.textContent = data.strings.chooseSize || '';
        return;
      }
      if (window.studio && typeof window.studio.addToCart === 'function') window.studio.addToCart(current.id, 1, addBtn);
      else form.submit();
    });

    /* barra fissa "Add to bag" (24-10, come Marachelle): compare quando il pulsante della scheda è sopra lo schermo; il
       pulsante della taglia apre un foglio con le copie di colori e taglie; "Add to bag" senza taglia apre il foglio */
    var sheet = root.querySelector('[data-tdf-stk-sheet]');
    if (stk && addBtn) {
      var slot = sheet && sheet.querySelector('[data-tdf-stk-slot]');
      if (slot) {
        root.querySelectorAll('.tdf-pdp__panel .tdf-pdp__opt').forEach(function (o) {
          var c = o.cloneNode(true);
          c.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
          c.querySelectorAll('[aria-labelledby]').forEach(function (x) { x.removeAttribute('aria-labelledby'); });
          c.querySelectorAll('[data-tdf-size-name]').forEach(function (x) { x.removeAttribute('data-tdf-size-name'); });
          var sz = c.querySelector('[data-tdf-sizes]');
          if (sz) { sz.removeAttribute('data-tdf-sizes'); sz.setAttribute('data-tdf-stk-sizes', ''); sz.setAttribute('aria-label', (stkPill && stkPill.dataset.word) || 'Size'); }
          c.querySelectorAll('.tdf-pdp__hint').forEach(function (x) { x.remove(); });
          slot.appendChild(c);
        });
        slot.addEventListener('click', function (e) {
          var b = e.target.closest('[data-size]');
          if (!b || b.getAttribute('aria-disabled') === 'true') return;
          selectSize(b.dataset.size);
          closeSheet();
        });
      }
      var lastFocus = null;
      function openSheet() {
        if (!sheet) return;
        lastFocus = document.activeElement;
        sheet.hidden = false;
        requestAnimationFrame(function () { sheet.classList.add('is-open'); });
        if (stkPill) stkPill.setAttribute('aria-expanded', 'true');
        var f = sheet.querySelector('[data-tdf-stk-sizes] [aria-checked="true"]') || sheet.querySelector('[data-tdf-stk-sizes] [data-size]:not([aria-disabled="true"])') || sheet.querySelector('button');
        if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
      }
      function closeSheet() {
        if (!sheet || sheet.hidden) return;
        sheet.classList.remove('is-open');
        if (stkPill) stkPill.setAttribute('aria-expanded', 'false');
        setTimeout(function () { sheet.hidden = true; }, 220);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      if (stkPill) stkPill.addEventListener('click', openSheet);
      if (sheet) sheet.addEventListener('click', function (e) { if (e.target.closest('[data-tdf-stk-close]')) closeSheet(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
      var stkAdd = stk.querySelector('[data-tdf-stk-add]');
      stkAdd.addEventListener('click', function () {
        if (!current) { openSheet(); return; }
        if (window.studio && typeof window.studio.addToCart === 'function') window.studio.addToCart(current.id, 1, stkAdd);
        else if (form) form.submit();
      });
      function setStk(show) {
        stk.classList.toggle('is-on', show);
        stk.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.documentElement.classList.toggle('tdf-stk-on', show);
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[en.length - 1];
          setStk(!e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(addBtn);
      }
    }

    /* consegna stimata: [from]–[to] giorni lavorativi da oggi, nel formato del paese */
    root.querySelectorAll('[data-tdf-eta]').forEach(function (el) {
      function addBiz(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
      var now = new Date();
      var fmt;
      try { fmt = new Intl.DateTimeFormat(el.dataset.country === 'US' ? 'en-US' : 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return; }
      var a = fmt.format(addBiz(now, parseInt(el.dataset.min, 10) || 5));
      var b = fmt.format(addBiz(now, parseInt(el.dataset.max, 10) || 7));
      el.querySelector('span').textContent = (el.dataset.text || '').replace('[from]', a).replace('[to]', b);
      el.hidden = false;
    });

    /* galleria sul telefono: contatore e puntini seguono lo scorrimento nativo */
    var gallery = root.querySelector('[data-tdf-gallery]');
    if (gallery) {
      var slides = Array.prototype.slice.call(gallery.children);
      var count = root.querySelector('[data-tdf-gcount]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-tdf-gdot]'));
      var active = -1, ticking = false;
      function update() {
        ticking = false;
        var w = gallery.clientWidth || 1;
        var i = Math.max(0, Math.min(slides.length - 1, Math.round(gallery.scrollLeft / w)));
        if (i === active) return;
        active = i;
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      gallery.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', function () { active = -1; update(); }, { passive: true });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          gallery.scrollTo({ left: k * gallery.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      update();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-tdf-sg]').forEach(initSizeChart);
    (scope || document).querySelectorAll('[data-tdf-pdp]').forEach(initProduct);
  }
  /* "Add one more for free shipping" nel carrello laterale (24-10): taglia scelta → studio.addToCart, che ridisegna il carrello */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-tdf-up-size]');
    if (s) s.classList.remove('is-err');
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tdf-up-add]');
    if (!b) return;
    e.preventDefault();
    var s = b.parentNode.querySelector('[data-tdf-up-size]');
    if (!s || !s.value) { if (s) { s.classList.add('is-err'); s.focus(); } return; }
    if (window.studio && typeof window.studio.addToCart === 'function') window.studio.addToCart(s.value, 1, b);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // editor del tema: sezioni ricaricate
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

// 27-10 home "The drop": alternativa A, pallini colore sulle schede (snippets/tdf-card-colours.liquid): toccando o passando
// sopra un pallino cambiano foto, seconda foto e link della scheda. Alternativa B, fila a scorrimento con le frecce.
(function () {
  function pick(dot) {
    var card = dot.closest('[data-tdf-pcs]');
    if (!card || dot.getAttribute('aria-pressed') === 'true') return;
    var link = card.querySelector('[data-tdf-pcs-link]');
    var a = card.querySelector('.tdf-pc__a'), b = card.querySelector('.tdf-pc__b');
    if (link && dot.dataset.url) link.href = dot.dataset.url;
    if (a && dot.dataset.aSrc) { a.removeAttribute('loading'); a.srcset = dot.dataset.a; a.src = dot.dataset.aSrc; a.alt = dot.dataset.alt || a.alt; }
    if (b) {
      if (dot.dataset.bSrc) { b.srcset = dot.dataset.b; b.src = dot.dataset.bSrc; b.hidden = false; }
      else b.hidden = true;
    }
    var label = card.querySelector('[data-tdf-pcs-color]');
    if (label && dot.getAttribute('title')) label.textContent = dot.getAttribute('title');
    Array.prototype.forEach.call(card.querySelectorAll('[data-tdf-pcs-dot]'), function (d) { d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-tdf-pcs-dot]');
    if (dot) { e.preventDefault(); pick(dot); }
  });
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest && e.target.closest('[data-tdf-pcs-dot]');
      if (dot) pick(dot);
    });
  }

  function bindRow(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';
    var row = root.querySelector('[data-tdf-drow-row]');
    var prev = root.querySelector('[data-tdf-drow-dir="-1"]'), next = root.querySelector('[data-tdf-drow-dir="1"]');
    if (!row || !prev || !next) return;
    function update() {
      var max = row.scrollWidth - row.clientWidth - 2;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= max;
      root.classList.toggle('is-static', max <= 0);
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tdf-drow-dir]');
      if (!btn) return;
      var card = row.firstElementChild;
      var step = card ? card.getBoundingClientRect().width : row.clientWidth;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      row.scrollBy({ left: step * Number(btn.dataset.tdfDrowDir), behavior: reduce ? 'auto' : 'smooth' });
    });
    row.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function initRows(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-tdf-drow]'), bindRow); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initRows(); });
  else initRows();
  document.addEventListener('shopify:section:load', function (e) { initRows(e.target); });
})();

// 27-10 scheda prodotto, sezione "Find the fit": il bottone della guida apre la finestra della tabella taglie della
// scheda (stesso comportamento di "Size guide"); senza la finestra resta il link alla pagina della guida.
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('[data-tdf-fit-guide]');
  if (!a) return;
  var opener = document.querySelector('[data-tdf-drawer-open^="tdf-size-"]');
  if (opener) { e.preventDefault(); opener.click(); }
});
